var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCake = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 18
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FEE1DB",
  d: "M.656 12.176h19.819v-1.985H.656z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF7053",
  d: "M1.181 13.765H19.82v-1.589H1.18zm0 3.838H19.82v-1.985H1.18zm2.1-7.412H17.72V6.618H3.28z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B6432B",
  d: "M0 18h21v-.662H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5AC0F7",
  d: "M9.581 6.618h1.838V3.044H9.58z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFEA6F",
  d: "M11.08 2.696c-.695.52-1.787-.108-1.345-.942.408-.814.562-1.638.562-1.638 1.114 1.285 1.357 2.158.783 2.58"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1191D6",
  d: "M9.614 6.629h.893V3.117h-.893z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB593B",
  d: "M3.305 10.14h7.202V6.744H3.305z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEE1DB",
  d: "M17.718 6.866c0 .708-.655 1.316-1.45 1.316-.796 0-1.44-.573-1.44-1.28 0 .707-.646 1.28-1.441 1.28s-1.44-.573-1.44-1.28c0 .707-.645 1.28-1.44 1.28-.796 0-1.44-.573-1.44-1.28 0 .707-.646 1.28-1.441 1.28s-1.44-.573-1.44-1.28c0 .707-.645 1.28-1.44 1.28-.796 0-1.464-.609-1.464-1.316V5.278h14.436v1.588z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB593B",
  d: "M1.167 17.3h9.34v-5.124h-9.34z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEE1DB",
  d: "M1.167 15.666h18.68v-1.938H1.166z"
}))));
export default SvgCake;